import { render, staticRenderFns } from "./account-detail.vue?vue&type=template&id=137c77ae&scoped=true"
import script from "./account-detail.vue?vue&type=script&lang=js"
export * from "./account-detail.vue?vue&type=script&lang=js"
import style0 from "./account-detail.vue?vue&type=style&index=0&id=137c77ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c77ae",
  null
  
)

export default component.exports